<script setup lang="ts">
import { zhCn } from 'element-plus/es/locale/index';
</script>

<template>
  <ElConfigProvider :locale="zhCn">
    <RouterView />
  </ElConfigProvider>
</template>
